import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api/user';
import { useIsMobile } from '../hooks/useIsMobile';
import {
  Stack,
  Card,
  CardBody,
  H2,
  Text,
  Input,
  Button,
  FormField,
} from '@neuro/design-system';

export default function LoginPage({ onLogin }: { onLogin?: () => void }) {
  const isMobile = useIsMobile();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      setLoading(false);
      if (onLogin) onLogin();
      navigate('/');
    } catch (err: any) {
      setLoading(false);
      setError(err?.response?.data?.message || 'Login failed');
    }
  };

  return (
    <Stack
      align="center"
      justify="center"
      style={{
        minHeight: '100vh',
        padding: isMobile ? 'var(--nc-space-4, 1rem)' : 0,
      }}
    >
      <Card padding="lg" style={{ maxWidth: 400, width: '100%' }}>
        <CardBody>
          <H2 className="nc-text--center">Login</H2>
          <form onSubmit={handleLogin}>
            <Stack gap={16} style={{ marginTop: 'var(--nc-space-6, 1.5rem)' }}>
              <FormField label="Username" required>
                <Input
                  type="text"
                  placeholder="Username"
                  value={username}
                  autoFocus
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                  fullWidth
                />
              </FormField>
              <FormField label="Password" required>
                <Input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                  fullWidth
                />
              </FormField>
              <Button
                type="submit"
                variant="primary"
                fullWidth
                loading={loading}
                disabled={!username || !password}
              >
                Login
              </Button>
              {error && (
                <Text color="error" size="sm">{error}</Text>
              )}
            </Stack>
          </form>
        </CardBody>
      </Card>
    </Stack>
  );
}